import './structureCumulative.css'

import type { StoreResponse } from 'api/Stores/types'
import { InfoElement } from 'components'
import React from 'react'
import { storeNameColumn } from 'TableCommon/defaultColumns'
import type { HeaderAdditionalComponentProps } from 'TableCommon/TableCommonHeader'
import type { Translate } from 'types'
import { formatNumberWithCurrency, getDifferenceWithPrecision } from 'utils'

import Box from '@mui/material/Box'

import { REVENUE_SORT_COLUMNS } from './constants'

interface Props {
  store: StoreResponse
  t: Translate
}

export default [
  storeNameColumn,
  {
    id: REVENUE_SORT_COLUMNS.REVENUE_CURRENT_PLN,
    classNameHeader: 'cell-revenue-current',
    classNameRow: 'cell cell-revenue-current',
    translation: ['rankings.revenueCurrent'],
    RowRenderer: ({ store, t }: Props) => (
      <Box>
        {formatNumberWithCurrency({
          number: store.revenueCurrent,
          translate: t,
        })}
      </Box>
    ),
  },
  {
    id: REVENUE_SORT_COLUMNS.REVENUE_PERCENT,
    classNameHeader: 'cell-revenuePercent',
    classNameRow: 'cell cell-revenuePercent',
    translation: ['search.table.percent'],
    RowRenderer: ({ store, t }: Props) => (
      <InfoElement
        percentDifference={getDifferenceWithPrecision({
          handleNullCase: true,
          number: store.revenuePercent,
          precision: 0,
          translate: t,
        })}
      />
    ),
  },
  {
    id: REVENUE_SORT_COLUMNS.REVENUE_PERCENT_YTD,
    classNameHeader: 'cell-ytd',
    classNameRow: 'cell cell-ytd',
    translation: ['revenue.details.result.ytd'],
    RowRenderer: ({ store, t }: Props) => (
      <InfoElement
        percentDifference={getDifferenceWithPrecision({
          handleNullCase: true,
          number: store.revenuePercentYtd,
          precision: 0,
          translate: t,
        })}
      />
    ),
  },
  {
    id: REVENUE_SORT_COLUMNS.REVENUE_PERCENT_QTD,
    classNameHeader: 'cell-qtd',
    classNameRow: 'cell cell-qtd',
    translation: ['revenue.details.result.qtd'],
    RowRenderer: ({ store, t }: Props) => (
      <InfoElement
        percentDifference={getDifferenceWithPrecision({
          handleNullCase: true,
          number: store.revenuePercentQtd,
          precision: 0,
          translate: t,
        })}
      />
    ),
  },
  {
    id: REVENUE_SORT_COLUMNS.REPLENISHMENT_SHOES,
    classNameHeader: 'cell-replenishmentOnHandShoesCurrent',
    classNameRow: 'cell cell-replenishmentOnHandShoesCurrent',
    HeaderAdditionalComponent: ({ id, onFilter }: HeaderAdditionalComponentProps) => (
      <Box display="inline" className="fm fm-replenishment" onClick={onFilter} data-value={id} />
    ),
    hideDefaultHeader: true,
    RowRenderer: ({ store, t }: Props) => (
      <InfoElement
        percentDifference={getDifferenceWithPrecision({
          handleNullCase: true,
          number: store.replenishmentOnHandShoesCurrent,
          precision: 0,
          translate: t,
        })}
      />
    ),
  },
]
